import { FormControlLabel, Radio, RadioGroup, styled } from '@mui/material';
import { DefaultProps } from '../../common/types';
import { ReactElement } from 'react';
import { CtrlErrorWrapper } from './CtrlErrorWrapper';

export interface Option {
    value: string;
    label: string;
}

export interface CtrlRadioProps extends DefaultProps {
    options: Option[];
    name?: string;
    value?: string;
    disabled?: boolean;
    children?: React.JSX.Element
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    error?: string;
}

function CtrlRadioComponent(props: CtrlRadioProps) {
    const { className, options, name, value, onChange, disabled, error } = props;

    return (
        <CtrlErrorWrapper error={error}>
            <RadioGroup value={value || ''} onChange={onChange} name={name} row className={className} >
                {options.map((option) => (
                    <FormControlLabel key={option.value} value={option.value} control={<Radio />} label={option.label} disabled={disabled}/>
                ))}
                {(props.children as ReactElement)}
            </RadioGroup>
        </CtrlErrorWrapper>
    );
}

export const CtrlRadio = styled(CtrlRadioComponent, { name: 'CtrlRadio' })(({ theme }) => ({
    ".MuiFormControlLabel-root": {
        marginLeft: "-4px",
    },
    ".MuiRadio-root": {
        padding: "4px",
    }
}));
